import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Register.css";

const Register = () => {
  const [formData, setFormData] = useState({
    user_id: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    wallet_balance: 0,
    password: "",
  });

  const [loading, setLoading] = useState(false);

  // 🔹 generate 3-digit user code
  useEffect(() => {
    const randomId = Math.floor(100 + Math.random() * 900);
    setFormData((prev) => ({ ...prev, user_id: randomId }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔒 basic validation
    if (formData.mobile.length !== 10) {
      alert("Mobile number must be 10 digits");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        "https://vahanapi.site/api/register.php",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (res.data.status) {
        alert("Registration successful ✅");
        // future: redirect to login
        // window.location.href = "/login";
      } else {
        alert(res.data.message || "Registration failed");
      }
    } catch (error) {
      alert("Server error ❌");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2 className="register-title">Register</h2>

        {/* User Code */}
        <input
          type="text"
          value={`User ID: ${formData.user_id}`}
          readOnly
        />

        <input
          type="text"
          name="first_name"
          placeholder="First Name"
          value={formData.first_name}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="last_name"
          placeholder="Last Name"
          value={formData.last_name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email ID"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          required
        />

    

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button type="submit" className="register-btn" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
      </form>
    </div>
  );
};

export default Register;
